import { Ref } from 'vue';

import { GetAccountTurnoverParamsType } from './requests';

const AP_URL = 'https://asan.shaparak.ir/';
const SHAPARAK_URL = 'https://sep.shaparak.ir/OnlinePG';
const BEH_PARDAKHT_URL = 'https://bpm.shaparak.ir/pgwchannel/startpay.mellat';

const PAY_FAST_INDEX = 0;
const PAY_FAST_MAX_VALUE = 2_000_000_000;
const MINIMUM_WITHDRAWAL_VALUE = 100000;

const WITHDRAWAL_CHANNEL_PREFIX = 'useri-';

const REQUEST_STATUS_ID = {
  canceled: [16],
  done: [2, 8],
  failed: [32, 4],
  open: [1],
};

const UPLOAD_LIMIT = 5242880; // 5 MB

const VALID_UPLOAD_TYPE = ['image/png', 'image/jpeg', 'application/pdf'];

const mobileInputName = {
  [BEH_PARDAKHT_URL]: 'MobileNo',
  [AP_URL]: 'mobileap',
};

const CASH_QUERY_KEYS = {
  brokerBankAccount: ['broker-bank-accounts'],
  depositReceipt: ['deposit-receipts'],
  payableAmounts: ['payable-amounts'],
  receiptAttachment: (attachmentId: number | null) => ['receipt', attachmentId],
  turnover: (params: Ref<GetAccountTurnoverParamsType>) => ['turnover', params],
  turnoverReport: (params: Ref<GetAccountTurnoverParamsType>) => [
    'turnover-report',
    params,
  ],
  withdrawals: ['last-withdrawal'],
  deposits: ['deposits'],
  cash: ['cash'],
  banksInformation: ['banks_information'],
  syncOnlineStatus: ['sync_online_status'],
};

const HELIUM_REGISTER_RECEIPT_SOURCE = 3;

const farabiAccountLink = import.meta.env.VITE_APP_FARABI_ACCOUNT_URL;
const ACTIVATE_DIRECT_DEBIT_LINK = `${farabiAccountLink}profile?item=directDebit`;

export {
  PAY_FAST_INDEX,
  PAY_FAST_MAX_VALUE,
  MINIMUM_WITHDRAWAL_VALUE,
  WITHDRAWAL_CHANNEL_PREFIX,
  REQUEST_STATUS_ID,
  UPLOAD_LIMIT,
  VALID_UPLOAD_TYPE,
  mobileInputName,
  AP_URL,
  SHAPARAK_URL,
  BEH_PARDAKHT_URL,
  CASH_QUERY_KEYS,
  HELIUM_REGISTER_RECEIPT_SOURCE,
  ACTIVATE_DIRECT_DEBIT_LINK,
};
